import { View, PLATFORM_OVERLAY_SMALL } from "@gaming/srvg-classes-core";
import { LivetableWidget } from "../../widgets/View/VfWidget/LivetableWidget";

export class AllGroupTablesView extends View {
    groups: string[];
    livetableWidgets: LivetableWidget[];

    constructor( options ) {
        options = options || {};
        super( options );

        this.livetableWidgets = [];

        let defaultGroups =
            (srvg.product.name === "vfwc" || "vfcc")
                ? ["A", "B", "C", "D", "E", "F", "G", "H"]
                : ["A", "B", "C", "D", "E", "F"];
        this.groups = options.groups || defaultGroups;
    }

    handleDomInstantiated() {
        if( srvg.widgets.enabled ) {
            if(srvg.widgets.widgets['livetable'].enabled){
                var that = this;
                $.each(this.groups, function(index, group){
                    that.livetableWidgets.push( that.addSubView(new LivetableWidget({
                        widgetGroup: srvg.widgets.widget_group,
                        selector: that.selector + ' div[data-group="'+group+'"]',
                        group: group,
                        platform: PLATFORM_OVERLAY_SMALL,
                        zoom: srvg.widgets.zoom,
                        zoomPosition: srvg.widgets.zoom_position,
                        showGroupHeader: true,
                        showActiveGroupBorder: false,
                        subscribeToLiveScoreMatch: false,
                        showTeamAbbr: (srvg.product.name === "vfwc" || "vfcc"),
                        // hide difference columns
                        diff: false,
                        score: true,
                        played: false,
                        change: false
                    })));
                });
            }
        }
    }
}